var DEFAULT_COLOR = '#000000';
export function hexToRGB(hexString, alpha) {
  var hex = hexString.search(/^#?[0-9a-fA-F]{6}$/) ? DEFAULT_COLOR : hexString;
  hex = hex.length === 6 ? "#".concat(hex) : hex;
  var r = parseInt(hex.slice(1, 3), 16);
  var g = parseInt(hex.slice(3, 5), 16);
  var b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(alpha, ")");
  } else {
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ")");
  }
}